import { render, staticRenderFns } from "./product-slider.vue?vue&type=template&id=70b2deb1"
import script from "./product-slider.vue?vue&type=script&lang=js"
export * from "./product-slider.vue?vue&type=script&lang=js"
import style0 from "./product-slider.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports